import { SectionLabel } from "@admin-ui/components/application/section-headers/section-label";
import type { ReactNode } from "react";

interface DetailRowProps {
  label: string;
  value: ReactNode;
}

export function DetailRow({ label, value }: DetailRowProps) {
  return (
    <>
      <div className="grid grid-cols-1 lg:grid-cols-[minmax(200px,280px)_minmax(400px,512px)] lg:gap-8">
        <SectionLabel.Root size="sm" title={label} className="max-lg:hidden" />
        <div className="flex items-center text-sm text-primary">{value}</div>
      </div>
      <hr className="h-px w-full border-none bg-border-secondary last:hidden" />
    </>
  );
}
